
























































































import Vue, { PropType } from 'vue';

import ModalMixin from '@/components/modal/mixin.vue';
import { Cv } from 'gen';

export default Vue.extend({
  mixins: [ModalMixin],
  props: {
    cv: {
      type: Object as PropType<Cv>,
      default: null,
    },
  },
  computed: {
    cvUrl() {
      return `${window.location.origin}/p/${this.cv?.original_path}`;
    },
  },
  methods: {
    onClickFB(e) {
      e.preventDefault();

      // prettier-ignore
      const url = `https://www.facebook.com/share.php?u=${this.cvUrl}`;
      window.open(
        encodeURI(decodeURI(url)),
        'facebookwindow',
        'width=550, height=450, personalbar=0, toolbar=0, scrollbars=1, resizable=0'
      );
      // @ts-ignore
      // FB.ui({ method: 'share', href: this.cvUrl }, function(_response) {});
    },
    onClickTwitter(e) {
      e.preventDefault();

      // prettier-ignore
      const url = `https://twitter.com/share?text=スマート履歴書を公開しました！&url=${encodeURIComponent(this.cvUrl)}&hashtags=スマート履歴書,プロフ&via=proff_jp&related=proff_jp`;
      window.open(
        url,
        'tweetwindow',
        'width=650, height=470, personalbar=0, toolbar=0, scrollbars=1, sizable=1'
      );
    },
    onClickLINE(e) {
      e.preventDefault();
      const url = `https://line.me/R/msg/text?${this.cvUrl}`;
      window.open(
        encodeURI(decodeURI(url)),
        'linewindow',
        'width=650, height=470, personalbar=0, toolbar=0, scrollbars=1, sizable=1'
      );
    },
    async copyToClipboard(e) {
      e.preventDefault();
      await this.$copyText(this.cvUrl);
      this.$notifySuccess('コピーしました');
    },
  },
});
